import { inBrowser, inLocalEnvironment } from 'shared/javascripts/util/environment'

/**
 * Whether a player may start by itself here at all. Autoplay is off in development and test so local work
 * and the system specs are not drowned in sound; `window.autoplay_enforced` is how the specs that are
 * *about* autoplay turn it back on (`test/support/helpers/video_helper.rb`).
 */
export function environmentAllowsAutoplay(): boolean {
  // An SSR-rendered component may ask during setup: nothing plays on a server, and there is no document
  // to read the environment from.
  if (!inBrowser()) {
    return false
  }

  return !inLocalEnvironment() || window.autoplay_enforced === true
}
